import React from 'react';
import { SubcategoryResponse } from '../../../../types/api/catalogs';
import { Stack, Text } from '@primer/react'

interface SubcategorySelectViewProps {
    subcategory: SubcategoryResponse;
    onSubcategoryClick: () => void;
}

export const SubcategorySelectView: React.FC<SubcategorySelectViewProps> = ({ subcategory, onSubcategoryClick }) => {

    return (
        <div className='h-[33px] w-full ml-[40px]'>
            <Stack direction="horizontal" align="center" className='w-full'>
                <div className="flex items-center w-full gap-4 overflow-hidden">
                    <div className="flex flex-col min-w-0">
                        <div
                            onClick={onSubcategoryClick}
                            className="flex items-center h-[20px] cursor-pointer">
                            <Text
                                className='truncate'
                                fontSize='14'
                                fontWeight="semibold"
                                color="fg.default">
                                {subcategory.title}
                            </Text>
                        </div>
                    </div>
                </div>
            </Stack>
        </div>
    );
};